const { helpers } = require("vuelidate/lib/validators");
module.exports = helpers.regex("phoneNumber", /^(09)\d{8}/);
